<template>
	<div class="p-10">
		<h1><svg-icon icon-class="store-solid" /> {{ $t('legalEntities') }}</h1>
		<el-row :gutter="5">
			<el-col :span="14">
				<el-card>
					<el-table :data="legalEntities" style="width: 100%" @row-click="handleRowClick">
						<el-table-column :prop="'registration_name'" :label="$t('name')" >
							<template slot-scope="scope">
								<router-link
									class="hover-underline fc-blue"
									:to="{
										name: 'legal-entity-detail',
										params: {
											id: scope.row.reference,
											participant: scope.row.participant
										}
									}"
								>
									{{ scope.row.registration_name }}
								</router-link>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import gql from 'graphql-tag';
import { mapGetters } from 'vuex';

const LEGAL_ENTITIES = gql`
query viewsLegalEntity__legal_entities ($participant: uuid!) {
	risolto_legal_entity(where: {participant: {_eq: $participant}}) {
		reference
		registration_name
		participant
	}
}
`;

export default {
	name: 'ViewsLegalEntityIndex',
	apollo: {
		legalEntities: {
			query: LEGAL_ENTITIES,
			variables() {
				return {
					participant: this.selectedParticipantStore
				};
			},
			update(data) {
				return data.risolto_legal_entity;
			}
		}
	},
	data() {
		return {};
	},
	computed: {
		...mapGetters(['env', 'selectedParticipantStore'])
	},
	methods: {
		handleRowClick(row) {
			this.$router.push({ name: 'legal-entity-detail', params: { id: row.reference, participant: row.participant } });
		}
	}
};
</script>
